import React, { useState } from 'react';
import { useCreateSerial } from '../../hooks';

import type { Serial } from '../../types';

interface CreateSerialFormProps {
  onCreated?: (newSerial: Serial | null) => void;
}

const CreateSerialForm: React.FC<CreateSerialFormProps> = ({
  onCreated
}) => {
  const [key, setKey] = useState('');
  const [description, setDescription] = useState('');

  const { mutate, isPending: isLoading, error } = useCreateSerial();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!key.trim()) {
      return;
    }
    mutate(
      { key, description: description || undefined },
      {
        onSuccess: (data) => {
          setKey('');
          setDescription('');
          onCreated?.(data);
        },
      }
    );
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-4"
    >
      <h3 className="text-xl font-display font-semibold text-on-surface">Create Show</h3>
      <div>
        <label htmlFor="serialKey" className="label">
          <span className="label-text">Key / Name</span>
        </label>
        <input
          type="text"
          id="serialKey"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          placeholder="e.g. my-next-series"
          className="input"
          required
        />
      </div>
      <div>
        <label htmlFor="serialDescription" className="label">
          <span className="label-text">Description (Optional)</span>
        </label>
        <textarea
          id="serialDescription"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Brief description of the series"
          className="textarea"
          rows={3}
        />
      </div>
      {error && <p className="text-error text-sm">{error.message}</p>}
      <div>
        <button type="submit" className="btn btn-primary" disabled={isLoading}>
          <span className="material-icons text-sm mr-1">add</span>
          {isLoading ? 'Creating...' : 'Create Series'}
        </button>
      </div>
    </form>
  );
};

export default CreateSerialForm;